module.exports = "/subscriptions/assets/f9268b968f5efedabc3331a00a08d540.svg";